import { Component, OnChanges, inject, ChangeDetectionStrategy, signal, input, output } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {MatIcon} from "@angular/material/icon";

import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";
import {StringUtils} from "../../../../utils/string-utils";

@Component({
    selector: 'app-clm-com-ratings',
    imports: [FormsModule, MatIcon],
    templateUrl: './clm-com-ratings.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './clm-com-ratings.component.css'
})
export class ClmComRatingsComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);


  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly imagePrefix = input.required<string>();
  readonly valueChanged = output<void>();
  modelSelection!: GuruEntity;
  configurationSelection!: GuruEntity;
  sizeSelection!: GuruEntity;
  returnAirSelection!: GuruEntity;
  supplyAirSelection!: GuruEntity;
  unitVoltageSelection!: GuruEntity;
  controlsSelection!: GuruEntity;
  cabinetInsulationSelection!: GuruEntity;
  waterCircuitSelection!: GuruEntity;
  heatExchangerOptionsSelection!: GuruEntity;
  optionsSelection!: GuruEntity;
  blowerMotorSelection!: GuruEntity;
  readonly handArrangementImagePath = signal<string>(undefined!);
  isExpanded = true;
  private sectionKey = ConfigurationSection.RATINGS;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.modelSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USModel');
    this.configurationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USConfiguration');
    this.sizeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSize');
    this.returnAirSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USReturnAir');
    this.supplyAirSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSupplyAirOptions');
    this.unitVoltageSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USUnitVoltage');
    this.controlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlOptions');
    this.cabinetInsulationSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinetInsulation');
    this.waterCircuitSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USWaterCircuitOptions');
    this.heatExchangerOptionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHeatExchangerOptions');
    this.optionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USExtendedOptions');
    this.blowerMotorSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USBlowerMotor');
    this.modelService.executeHierarchy(this.engineKey(), 'hierDOC').subscribe(() => {
      this.modelService.getCharacteristicValue(this.engineKey(), 'UnitHandArrangementImage', 'FileName').subscribe(result => {
        this.handArrangementImagePath.set(this.imagePrefix() + result);
      });
    });
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

  isHandArrangementImageAvailable(): boolean {
    return StringUtils.isNotBlank(this.imagePrefix()) && StringUtils.isNotBlank(this.handArrangementImagePath());
  }

}
